<!--
~ Copyright (C) 2021 DV Bern AG, Switzerland
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as
~ published by the Free Software Foundation, either version 3 of the
~ License, or (at your option) any later version.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. If not, see <https://www.gnu.org/licenses/>.
-->
<div
    class="gemeinde-antraege-view"
    dv-show-element
    dv-show-allowed-roles="vm.TSRoleUtil.getAllRolesForLastenausgleich()"
>
    @if (canCreateAntrag() | async) {
        <form
            role="form"
            class="gemeinde-antraege-form"
            unsaved-warning-form=""
            novalidate
            dv-show-element
            [formGroup]="formGroup"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="row gemeinde-antraege-form-row">
                        <!-- Jahr -->
                        <div class="col-xs-12 col-sm-12 col-md-4">
                            <label
                                class="md-no-float required ignore-danger-font-color"
                                for="gemeindeantragperiode"
                                translate
                                >GESUCHSPERIODEN</label
                            >
                            <select
                                aria-describedby="gemeindeantragtyp-error"
                                name="gemeindeantragperiode"
                                id="gemeindeantragperiode"
                                [formControl]="formGroup.controls.periode"
                                class="form-control"
                                data-test="gemeindeantraege-periode"
                            >
                                <option value="" style="display: none"></option>
                                @for (
                                    periode of getGesuchsperiodenOptions();
                                    track periode
                                ) {
                                    <option [value]="periode.id">
                                        {{ periode.gesuchsperiodeString }}
                                    </option>
                                }
                            </select>
                            <div class="dv-error-messages">
                                @if (
                                    (formGroup.controls.periode.touched ||
                                        triedSending) &&
                                    formGroup.controls.periode.errors?.required
                                ) {
                                    <div class="error" translate>
                                        ERROR_REQUIRED
                                    </div>
                                }
                            </div>
                        </div>
                        <!-- Gemeindeantragtyp -->
                        <div class="col-xs-12 col-sm-12 col-md-4">
                            <div>
                                <label
                                    class="md-no-float required ignore-danger-font-color"
                                    for="gemeindeantragtyp"
                                    translate
                                    >TYP</label
                                >
                                <select
                                    aria-describedby="gemeindeantragtyp-error"
                                    name="gemeindeantragtyp"
                                    id="gemeindeantragtyp"
                                    [formControl]="formGroup.controls.antragTyp"
                                    (change)="onAntragTypChange()"
                                    class="form-control"
                                    data-test="gemeindeantraege-typ"
                                >
                                    @for (typ of creatableTypes; track typ) {
                                        <option [value]="typ" translate>
                                            {{ typ }}
                                        </option>
                                    }
                                </select>
                                <div class="dv-error-messages">
                                    @if (
                                        (formGroup.controls.antragTyp.touched ||
                                            triedSending) &&
                                        formGroup.controls.antragTyp.errors
                                            ?.required
                                    ) {
                                        <div class="error" translate>
                                            ERROR_REQUIRED
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <!--                        Gemeinde-->
                        @if (ferienBetreuungSelected()) {
                            <div class="col-xs-12 col-sm-12 col-md-3">
                                <div>
                                    <label
                                        class="md-no-float ignore-danger-font-color"
                                        [ngClass]="{
                                            required: ferienBetreuungSelected()
                                        }"
                                        for="select-gemeinde"
                                        translate
                                        >GEMEINDE</label
                                    >
                                    <select
                                        aria-describedby="select-gemeinde-error"
                                        name="gemeinde"
                                        id="select-gemeinde"
                                        [formControl]="
                                            formGroup.controls.gemeinde
                                        "
                                        class="form-control"
                                    >
                                        @for (
                                            gemeinde of gemeinden;
                                            track gemeinde
                                        ) {
                                            <option [value]="gemeinde.id">
                                                {{ gemeinde.name }}
                                            </option>
                                        }
                                    </select>
                                    <div class="dv-error-messages">
                                        @if (
                                            (formGroup.controls.gemeinde
                                                .touched ||
                                                triedSending) &&
                                            formGroup.controls.gemeinde.errors
                                                ?.required
                                        ) {
                                            <div class="error" translate>
                                                ERROR_REQUIRED
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="row tw:mb-12 tw:pb-12 gemeinde-antraege-form-actions">
                <div class="col-xs-12 col-sm-12">
                    <div class="tw:pl-9">
                        <!-- Create LATS Antraege Button -->
                        @if (
                            !ferienBetreuungSelected() && isMandant() | async
                        ) {
                            <div
                                dvLoadingButtonX
                                [ariaLabel]="
                                    'LATS_ANTRAEGE_ERSTELLEN' | translate
                                "
                                type="submit"
                                (buttonClick)="createAllAntraege()"
                                data-test="gemeindeantraege-antraege-erstellen"
                                class="gemeindeantraege-antraege"
                            >
                                <span class="tw:uppercase" translate
                                    >LATS_ANTRAEGE_ERSTELLEN</span
                                >
                            </div>
                        }

                        <!-- Gemeinde Antrag Button -->
                        @if (ferienBetreuungSelected()) {
                            <div
                                dvLoadingButtonX
                                [ariaLabel]="
                                    'GEMEINDE_ANTRAEGE_ANTRAG_ERSTELLEN'
                                        | translate
                                "
                                type="submit"
                                (buttonClick)="createAntrag()"
                                class="gemeindeantraege-antraege"
                            >
                                <span class="tw:uppercase" translate
                                    >GEMEINDE_ANTRAEGE_ANTRAG_ERSTELLEN</span
                                >
                            </div>
                        }

                        <!-- Delete LATS Button -->
                        @if (
                            !ferienBetreuungSelected() && latsDeletePossible$
                                | async
                        ) {
                            <button
                                type="button"
                                class="dv-btn cancel-button tw:ml-8"
                                (click)="deleteAllLatsAntraege()"
                                data-test="gemeindeantraege-antraege-loeschen"
                            >
                                <span class="tw:uppercase" translate
                                    >LATS_ANTRAEGE_LOESCHEN</span
                                >
                            </button>
                        }
                    </div>
                </div>
            </div>
        </form>
    }

    <dv-new-antrag-list
        [hiddenColumns]="hiddenDVTableColumns"
        [data$]="antragList$"
        (rowClicked)="navigate($event.antrag, $event.event)"
        [page]="calculatePage()"
        (filterChange)="onFilterChange($event)"
        (sortChange)="onSortChange($event)"
        (paginationEvent)="onPagination($event)"
        [filterStateList]="getStateFilter()"
        [filterTypeList]="types"
        [stateStoreId]="'gemeindeantraege'"
        [showRemoveButton]="isMandant() | async"
        (removeClicked)="deleteGemeindeAntrag($event)"
        [totalItems]="totalItems"
    ></dv-new-antrag-list>
</div>
